import { useTranslation } from 'react-i18next'

import {
  ButtonSelect,
  getSelectDropdownListFloatingConfig,
  InputMultiSelectControl,
  MultiSelect,
  SELECT_DROPDOWN_LIST_MAX_HEIGHT_AVATARED_ENTITY,
} from '../../Select'
import { getLabelEntitySelectOptions } from '../Label.utils'

function LabelEntityMultiSelect({
  Control = InputMultiSelectControl,
  dropdownFloatingConfig = getSelectDropdownListFloatingConfig(
    SELECT_DROPDOWN_LIST_MAX_HEIGHT_AVATARED_ENTITY
  ),
  tagsProps,
  onClear,
  onSelectItem,
  ...restProps
}) {
  const { t } = useTranslation()

  const options = getLabelEntitySelectOptions(t)

  return (
    <MultiSelect
      {...restProps}
      Control={Control}
      Select={ButtonSelect}
      dropdownFloatingConfig={dropdownFloatingConfig}
      options={options}
      tagsProps={{
        ...tagsProps,
        onChange: onSelectItem,
        onClear,
      }}
      onClear={onClear}
      onSelectItem={onSelectItem}
    />
  )
}

export default LabelEntityMultiSelect
